/* ======================================================================== */
/* 6. PJAX Init New Page */
/* ======================================================================== */
function PJAXInitNewPage(data) {

	return new Promise(function (resolve, reject) {

		var $nextContainer = $(data.next.container);

		Promise.all([
				PJAXUpdateBody(data),
				PJAXUpdateNodes(data),
				PJAXUpdateHead(data),
				PJAXUpdateAdminBar(data),
				PJAXUpdateLanguageSwitcher(data),
				fontObserver(),
			])
			.then(function () {
				return doSplitText($nextContainer);
			})
			.then(function () {
				return setLines($nextContainer);
			})
			.then(function () {
				return setChars($nextContainer);
			})
			.then(function () {

				// clear & re-init ScrollMagic
				window.SMController.destroy(true);
				window.SMController = new ScrollMagic.Controller();

				// re-init components
				initComponents($nextContainer);

				// don't start animations immediately
				window.SMController.enabled(false);

				// scroll at the page beginning
				scrollToVeryTop();
				// ensure that scroll is still locked
				lockScroll(true);

				// init Elementor frontend
				if (typeof window.elementorFrontend !== 'undefined') {
					elementorFrontend.init();
				}

				// update ad trackers
				PJAXUpdateTrackers();

				resolve(true);

			});
	});

}
